export const toPersonnelLatLng = (loc = {}) => {
  const lat = Number(loc.lat ?? loc.latitude);
  const lng = Number(loc.lng ?? loc.longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng)) return [lat, lng];
  return null;
};

export const getPersonnelLocationTimestamp = (loc) => {
  const raw = loc?.timestamp ?? loc?.time ?? loc?.ts ?? loc?.updatedAt;
  if (raw == null) return null;
  const value = Number(raw);
  return Number.isFinite(value) ? value : null;
};

/**
 * Resolve the best available current location for personnel records.
 * Prefers the most recent timestamp across known location fields.
 */
export const pickLatestPersonnelLocation = (person) => {
  const candidates = [];
  const pushCandidate = (loc) => {
    const latLng = toPersonnelLatLng(loc);
    if (!latLng) return;
    candidates.push({ loc, latLng });
  };

  // Check single location object and lastStationaryLoc
  pushCandidate(person?.location);
  pushCandidate(person?.lastStationaryLoc);

  if (!candidates.length) return { loc: null, latLng: null };

  // If only one candidate, return it
  if (candidates.length === 1) return candidates[0];

  // Compare timestamps and return the most recent
  let best = candidates[0];
  for (let i = 1; i < candidates.length; i += 1) {
    const current = candidates[i];
    const bestTs = getPersonnelLocationTimestamp(best.loc);
    const currentTs = getPersonnelLocationTimestamp(current.loc);
    if (currentTs != null && (bestTs == null || currentTs > bestTs)) {
      best = current;
    }
  }

  return { loc: best.loc, latLng: best.latLng };
};
